import { useState, useEffect } from 'react';
import { dataHelpers } from '../lib/supabase';

export const useUnreadMessages = (parentId) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchUnreadCount = async () => {
    if (!parentId) return;
    
    try {
      setLoading(true);
      const messages = await dataHelpers.getMessagesByRecipient(parentId);
      const unread = messages.filter(msg => !msg.read_at).length;
      setUnreadCount(unread);
    } catch (error) {
      console.error('Error fetching unread messages count:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
  }, [parentId]);

  return {
    unreadCount,
    loading,
    refresh: fetchUnreadCount
  };
};
